import Axios from '../Axios';

const permission = {
	create(data) {
		return Axios.post('/permissions', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/permissions?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/permissions/' + id);
	},
	update(id, data) {
		return Axios.put('/permissions/' + id, data);
	},
	delete(id) {
		return Axios.delete('/permissions/' + id);
	},
};

export default permission;
